export const CLIENT_HASH_KEYS = {
    event_source_url: location.hostname,
    domain: location.hostname,
    userAgent: navigator.userAgent,
    redirect_url: '',
};

export const TIME_KEYS = {
    timestamp: Date.now(),
    timestamp_millis: Date.now() / 1000,
    timestamp_format: new Date().toISOString().slice(0, 19).replace('T', ' '),
};

export const CLIENT_EVENT_NAME = {
    LOGIN: 'login',
    LOGIN_COMPLETE: 'login_complete',
    SIGN_UP: 'signup',
    SIGN_UP_COMPLETE: 'signup_complete',
    SIGN_UP_START: 'signup_start',
    LOGOUT: 'logout',
    OPENBROWSER: 'openBrowser',
};

export const getClientHashKeys = ({ login, aff_id, referralSource, platformTrackingId }) => {
    return {
        ...CLIENT_HASH_KEYS,
        platformTrackingId,
        login,
        aff_id,
        referral: referralSource,
    };
};
